export default {
  isDialogDisplayed: false,
};
